import type { CaseChip } from "@/api/club/ClubApi";
import { routes } from "@/constants/routes";
import { ANIMAL_STATUS_LABEL, labelOf } from "@/constants/uiLabels";
import { StatusChip, statusToneFor } from "@/ui/components/StatusChip";
import { useRouter } from "expo-router";
import { Pressable } from "react-native";

/**
 * Kompakter Tier-Chip aus resolve_case_chips.
 * Klick öffnet die Tierakte (normale Rechte gelten dort).
 */
export function CaseChipView({
  chip,
  unavailableLabel = "Tier nicht verfügbar",
}: {
  chip: CaseChip | null | undefined;
  unavailableLabel?: string;
}) {
  const router = useRouter();

  const available =
    chip &&
    chip.available !== false &&
    !!(chip.case_number || chip.name);

  if (!available || !chip) {
    return (
      <StatusChip label={unavailableLabel} tone="neutral" size="sm" active={false} />
    );
  }

  const statusLabel = chip.status
    ? labelOf(ANIMAL_STATUS_LABEL, chip.status)
    : null;
  const label = [chip.case_number, chip.name, statusLabel]
    .filter(Boolean)
    .join(" · ");

  return (
    <Pressable
      onPress={() => router.push(routes.myAnimal(chip.case_id) as never)}
      accessibilityRole="link"
      accessibilityLabel={`Tier ${label}`}
    >
      <StatusChip
        label={label}
        tone={statusToneFor(chip.status ?? "")}
        size="sm"
      />
    </Pressable>
  );
}
